import { atom } from 'jotai';

export const isSidebarAlertOpenState = atom<boolean>(false);

/**
 * Demande d’ouverture de la modale « Importer des coupons » (codes promo).
 * Écriture : `AlertSidebar` (CTA depuis l’alerte coupons manquants).
 * Lecture / reset : `ImportButton` (ouvre le Dialog existant sur `couponCodesImport`).
 */
export const openImportCouponCodesModalAtom = atom(false);
